module.exports = __webpack_public_path__ + "assets/img/companyicon6.dc9405a4.jpg";